import type { ReactNode } from 'react';
import IconButton from './IconButton';
import IconWithConnector from './IconWithConnector';

interface IconContainerProps {
  icon: ReactNode;
  isActive: boolean;
  onClick: () => void;
  position: 'first' | 'middle' | 'last';
  className?: string;
  label: string;
}

export default function IconContainer({
  icon,
  isActive,
  onClick,
  position,
  className,
  label,
}: IconContainerProps) {
  return (
    <IconWithConnector isActive={isActive} position={position}>
      <IconButton
        icon={icon}
        isActive={isActive}
        onClick={onClick}
        className={className}
        label={label}
      />
    </IconWithConnector>
  );
}
